// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgPowerGridIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12 2a1 1 0 0 1 .948.684L13.721 5H17a1 1 0 1 1 0 2h-2.613l1 3H19a1 1 0 1 1 0 2h-2.946l2.894 8.684a1 1 0 0 1-1.655 1.023L12 16.414l-5.293 5.293a1 1 0 0 1-1.655-1.023L7.946 12H5a1 1 0 1 1 0-2h3.613l1-3H7a1 1 0 0 1 0-2h3.28l.772-2.316.061-.147A1 1 0 0 1 12 2M8.287 17.298 10.586 15l-1.15-1.15zM13.414 15l2.298 2.298-1.15-3.447zm-3-3L12 13.586 13.585 12h-3.17Zm.307-2h2.558l-1-3h-.558z"
      clipRule="evenodd"
    />
  </g>
);
export default SvgPowerGridIcon;
SvgPowerGridIcon.displayName = 'SvgPowerGridIcon';
